import React from 'react';
import { UserList } from '../../';
import { User } from '@breakroom-nx/classes';

// Redux
import { useGetFriendsForUserWithUIDQuery } from '@breakroom-nx/redux';

export interface FriendListTableViewProps {
  user: User;
}

export function FriendListTableView({ user }: FriendListTableViewProps) {
  const {
    data: friends,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetFriendsForUserWithUIDQuery(user.uid);

  return (
    <UserList
      title={'Friends'}
      data={friends}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      error={error}
      refetch={refetch}
    />
  );
}

export default React.memo(FriendListTableView);
